export const variantsColumns = [
  {
    accessorKey: "name", //access nested data with dot notation
    header: "Name",
  },
];
